































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import maps, { R6Map, mapIds } from '@/maps';
import { QUICK_MATCH, RANKED } from '@/maps/Rotation';

@Component({
  components: {}
})
export default class MapSelector extends Vue {
  @Prop({
    default: () => {
      return Object.values(maps);
    }
  })
  private readonly list!: R6Map[];
  private publicPath = process.env.BASE_URL;

  readonly filter = {
    all: 0,
    quickplay: 1,
    ranked: 2
  };
  private selectedFilter = this.filter.all;

  private _ROTATIONS: { [key: number]: any } | null = null;

  ROTATIONS: { [key: number]: any } = {
    [this.filter.all]: {
      labelid: 'ui.map-selector.filter-all',
      color: null,
      icon: 'mdi-all-inclusive',
      rotation: Object.values(maps)
    },
    [this.filter.quickplay]: {
      labelid: 'ui.map-selector.filter-quickplay',
      color: 'orange',
      icon: 'mdi-flash',
      rotation: Object.values(maps).filter(value =>
        QUICK_MATCH.includes(value.id)
      )
    },
    [this.filter.ranked]: {
      labelid: 'ui.map-selector.filter-ranked',
      color: 'yellow',
      icon: 'mdi-star',
      rotation: Object.values(maps).filter(value => RANKED.includes(value.id))
    }
  };

  // @Watch('selectedFilter')
  public get rotation() {
    return this.ROTATIONS[this.selectedFilter].rotation;
  }

  // private compare: (a: R6Map, b: R6Map) => number = (a, b) => {
  //   return 1;
  // };
}
